import React, { useEffect, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import "./Notifications.css";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import {
  GETLevel,
  GetUserNotification,
} from "../../../features/admin/auth/Slice";
import { useDispatch, useSelector } from "react-redux";

const tabs = ["All Activities", "Orders", "Levels", "Transaction"];

const tabToTypeMap = {
  "All Activities": "",
  Orders: 1,
  Levels: 2,
  Transaction: 3,
  // Security: 4, // (only if exists in backend)
};
const notificationsData = [
  {
    id: 1,
    type: "Orders",
    title: "Order Shipped",
    message:
      "Good news! Your Spirulina Super-Greens order has been shipped and is expected to arrive within 2–3 business days.",
    time: "Just Now",
    icon: "/images/order.png",
  },
  {
    id: 2,
    type: "Transaction",
    title: "Wallet Credited",
    message:
      "Your referral bonus of ₹100 has been successfully added to your wallet.",
    time: "5 Min ago",
    icon: "/images/wallet.png",
  },
  {
    id: 3,
    type: "Transaction",
    title: "Wallet Credited",
    message:
      "Your referral bonus of ₹100 has been successfully added to your wallet.",
    time: "Yesterday",
    icon: "/images/wallet.png",
  },
  {
    id: 4,
    type: "Levels",
    title: "New Level Unlocked",
    message:
      "Congratulations! You've successfully moved up to the next level. Keep growing your network to unlock more rewards.",
    time: "2 Oct 2025",
    icon: "/images/level.png",
  },
];

const Notifications = () => {
  const [activeTab, setActiveTab] = useState("All Activities");

  const dispatch = useDispatch();
  const userNotification = useSelector(
    (state) => state?.auth?.login?.getUserNotificationData,
  );


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  useEffect(() => {
    const type = tabToTypeMap[activeTab];

    dispatch(GetUserNotification(type));
  }, [dispatch, activeTab]);

  const filteredData =
    activeTab === "All Activities"
      ? notificationsData
      : notificationsData.filter((item) => item.type === activeTab);

  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Order Hostory" },
  ];

  return (
    <div className="notifications-page">
      <CommonBreadcrumb items={breadcrumbItems} />
      <Container className="container-section">
        <p className="sub-text">
          Check the latest updates related to your account.
        </p>

        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(selectedKey) => setActiveTab(selectedKey)}
          className="custom-tabs"
        >
          {tabs.map((tab, index) => (
            <Nav.Item key={index}>
              <Nav.Link eventKey={tab}>{tab}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <div className="notifications-list">
          {userNotification?.map((item, index) => (
            <div
              className={`notification-card ${
                index < 2 ? "green-card" : "gray-card"
              }`}
              key={item.id}
            >
              <div className="left">
                <div className="info">
                  <h6>{item?.title}</h6>
                  <p>{item?.description}</p>
                </div>
              </div>

              <span className="time">{formatDateTime(item?.created_at)}</span>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Notifications;
